import MediasPreview from '../../../media/MediasPreview/MediasPreview';

interface CatalogMediaPreviewDialogProps {
  urls: string[];
  selectedUrl: string | null;
  onClose: () => void;
}

const toPreviewMedia = (url: string) => ({ url, type: 'IMAGE' as const, fileName: url });

const CatalogMediaPreviewDialog = ({
  urls,
  selectedUrl,
  onClose,
}: CatalogMediaPreviewDialogProps) => {
  if (!selectedUrl) {
    return null;
  }

  return (
    <MediasPreview
      open
      medias={urls.map(toPreviewMedia)}
      selectedMedia={toPreviewMedia(selectedUrl)}
      onClose={onClose}
    />
  );
};

export default CatalogMediaPreviewDialog;
